// extracted by mini-css-extract-plugin
export default {"container":"filterPlague_container__nBzdf","filterPlagueContainer":"filterPlague_filterPlagueContainer__E4yq3","switchContainer":"filterPlague_switchContainer__6sQOF"};